// Stage 8.3 of EVALUATIONS_EXECUTION_HANDOFF.md removed every other
// type this file used to export -- each one was only ever dispatched
// or read by the old evaluation pages/forms deleted in this same
// stage (confirmed by grep before removing anything). These two
// survive because they still have a live, unrelated caller:
// setEvaluationResults from the dashboard's WidgetsDropdown.js widget,
// starOfTheMonthEmployee from the Star of the Month widget
// (src/views/atoms/starOfTheMonth.js) -- neither is part of the
// evaluations feature this restructure touched.
export const setEvaluationResults = "setEvaluationResults";
export const starOfTheMonthEmployee = "starOfTheMonthEmployee";
